import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase, getLocalUser } from '../supabase';
import { theme } from '../theme';
import { LogoCompact } from '../Icons';
import AccountScreenBanner from './AccountScreenBanner';
import { updateFirstName } from '../api/atlast';

// ChangeNameScreen — new (Sep 8, per Ali's report). The editability
// half of the first-name feature — the other half is the optional
// signup field in Login.js, and this is the safety net for anyone who
// skipped it there, plus how anyone changes it later. Mirrors
// EmailChangeScreen.js's structure exactly, same reasoning: reads as
// the same product, not a bolted-on utility screen.
function ChangeNameScreen() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [firstName, setFirstNameInput] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    getLocalUser().then(async ({ data }) => {
      if (!data?.user?.id) return;
      setUserId(data.user.id);
      const { data: userRow } = await supabase
        .from('users')
        .select('first_name')
        .eq('id', data.user.id)
        .single();
      if (userRow?.first_name) setFirstNameInput(userRow.first_name);
    });
  }, []);

  const handleSubmit = async () => {
    setError(null);
    const trimmed = firstName.trim();

    if (!trimmed) {
      setError('Enter a first name.');
      return;
    }

    setSubmitting(true);
    try {
      await updateFirstName(userId, trimmed);
      setDone(true);
      setTimeout(() => navigate('/dashboard'), 900);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Could not update your name. Try again.');
    }
    setSubmitting(false);
  };

  return (
    <>
      <AccountScreenBanner section="Change Name" />
      <div className="login-form-panel" style={{ minHeight: 'calc(100vh - 60px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="login-card yedge">
          <div className="login-card-body">
            <div className="login-card-icon">
              <LogoCompact width={150} color="#1E3A5F" />
            </div>
            <h2 style={{ textAlign: 'center', margin: '0 0 4px', color: theme.textPrimary, fontFamily: theme.fontDisplay }}>
              Change your name
            </h2>
            <p style={{ textAlign: 'center', color: theme.textMuted, margin: '0 0 24px' }}>
              {done ? "You're all set." : 'This is just for your Dashboard greeting.'}
            </p>

            {!done ? (
              <>
                <label>First name</label>
                <div className="login-input-wrap">
                  <input
                    type="text"
                    placeholder="Sarah"
                    value={firstName}
                    onChange={(e) => setFirstNameInput(e.target.value)}
                  />
                </div>

                {error && (
                  <p style={{ fontSize: '12.5px', color: theme.danger, marginTop: '8px', marginBottom: 0, fontWeight: 600 }}>{error}</p>
                )}

                <button
                  className="btn-primary login-submit-btn"
                  style={{ marginTop: '20px', width: '100%' }}
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? 'Saving…' : 'Save name'}
                </button>
                <p
                  onClick={() => navigate('/dashboard')}
                  style={{ textAlign: 'center', fontSize: '12.5px', color: theme.textMuted, marginTop: '16px', cursor: 'pointer' }}
                >
                  Cancel
                </p>
              </>
            ) : (
              <p style={{ textAlign: 'center', fontSize: '13px', color: theme.textPrimary, lineHeight: 1.6 }}>
                Taking you to your Dashboard…
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangeNameScreen;